<template>
  <div>
    <h3>Daily Bonus</h3>
    <p>The bonus for the first deposit of the day is calculated daily as {{bonus.percent}}% of the deposit amount.</p>
    <p>Each bonus is provided under certain conditions and with certain limitations that the User should comply with in order to be able to withdraw bonus funds from the account. Depending on the type of the bonus offered, you may be required to fulfil certain conditions in order to be able to withdraw from the account the funds obtained as a result of a successful betting involving the bonus.</p>
    <h5>Bonus accrual</h5>
    <ol>
      <li>Top-up your balance.</li>
      <li>The bonus is automatically accrued after the player replenishes the balance, provided that they currently have no other active bonuses.</li>
    </ol>

    <h5>Terms and conditions</h5>
    <ol>
      <li>The User is eligible only for 1 bonus per day.</li>
      <li>The bonus is automatically accrued after the first deposit to the account, provided that the player has no other active bonuses at the moment.</li>
      <li>The withdrawal of bonus funds is not possible until the turnover terms are fulfilled.</li>
      <li>
        Turnover terms
        <ul>
          <li v-if="redPipe && redPipe.contributionPercent > 0">
            Casino: {{redPipe.contributionPercent}}% from each bet below
            <template v-for="cs in redPipe.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} for {{cs.currency}},
            </template>
          </li>
          <li v-if="flg && flg.contributionPercent > 0">
            Live Games: {{flg.contributionPercent}}% from each bet below
            <template v-for="cs in flg.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} for {{cs.currency}},
            </template>
          </li>
          <li v-if="bk && bk.contributionPercent > 0">
            Sport: {{bk.contributionPercent}}% from each bet below
            <template v-for="cs in bk.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} for {{cs.currency}},
            </template>
            with the rate >= {{bk.minFactor}}
          </li>
          <li v-if="hdRaces && hdRaces.contributionPercent > 0">
            Virtual Sports: {{hdRaces.contributionPercent}}% from each bet below
            <template v-for="cs in hdRaces.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} for {{cs.currency}},
            </template>
            with the rate >= {{hdRaces.minFactor}}
          </li>
        </ul>
      </li>
      <li>The offer cannot be applied in combination with other promotions or special offers.</li>
      <li>We grant only one bonus per user, family, address, shared computer, common IP-address and any identical account data, such as e-mail, bank account, credit card details or payment system account. In case of any violation of the rules of the bonus program, the account shall be disabled.</li>
      <li>The turnover bonus is transferred to the main account in the amount of the bonus funds on the balance, but not more than {{bonus.convertToRealMaxPercent}}% from initial bonus value.</li>
      <li>If any funds are withdrawn, the bonus shall be cancelled.</li>
      <li>The rules of the promotion are subject to change.</li>
    </ol>
  </div>
</template>
<script>
  import Vue from "vue";

  export default {
    name: 'bonus-rules-deposit-en',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
          redPipe: null,
          flg: null,
          bk: null,
          hdRaces: null
      }
    },
    computed: {
      currency() {
        let player = Vue.state.player.get();
        return player && player.balance && player.balance.currency;
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.redPipe = this.bonus.providers.filter(p => p.provider == 'redpipe')[0];
        this.flg = this.bonus.providers.filter(p => p.provider == 'flg')[0];
        this.bk = this.bonus.providers.filter(p => p.provider == 'bk')[0];
        this.hdRaces = this.bonus.providers.filter(p => p.provider == 'hdraces')[0];
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/en.vue